

const super_admin_gradient: string = "linear(to-r, blue.300, blue.400, blue.500)";

export default super_admin_gradient;